"use client";

import { TwitterShareButton, TwitterIcon } from "react-share";
import css from "./PostShareButton.module.css";
import { Post } from "@forcode/domain";

export interface PostShareButtonProps {
  post: Post;
}

const BASE_CLASS = "f-OrganismPostShareButton";

export const PostShareButton = ({ post }: PostShareButtonProps) => {
  const { title, url } = post;

  return (
    <div className={css[BASE_CLASS]}>
      <span className={css[`${BASE_CLASS}-shareText`]}>Compartir en: </span>
      <TwitterShareButton
        url={url}
        title={title}
        via="forCodeOfficial"
        hashtags={post.tags}
      >
        <TwitterIcon size={32} round={true} />
      </TwitterShareButton>
    </div>
  );
};
